import React from 'react';
import GeniLoader from '../../components/GeniLoader';

export const OptionsLoadingState = ({
  title,
  description = null,
  minHeight = 280,
  size = 'lg',
  testId = 'options-loading-state',
}) => {
  return (
    <div
      className="overflow-hidden rounded-[28px] border border-white/10 bg-[radial-gradient(circle_at_top,_rgba(0,230,118,0.10),_transparent_36%),linear-gradient(180deg,rgba(255,255,255,0.035),rgba(255,255,255,0.015))] px-6 py-10"
      data-testid={testId}
    >
      <div
        className="mx-auto flex max-w-xl flex-col items-center justify-center gap-4 text-center"
        style={{ minHeight }}
        data-testid={`${testId}-content`}
      >
        <div className="rounded-full border border-white/10 bg-black/25 px-5 py-5 shadow-[0_0_0_1px_rgba(255,255,255,0.02)]" data-testid={`${testId}-brain-wrap`}>
          <GeniLoader size={size} />
        </div>
        {title ? (
          <div className="space-y-2" data-testid={`${testId}-copy`}>
            <p className="text-sm font-semibold uppercase tracking-[0.24em] text-[#9BFFBE]" data-testid={`${testId}-title`}>
              {title}
            </p>
            {description ? (
              <p className="text-sm text-white/60 sm:text-base" data-testid={`${testId}-description`}>
                {description}
              </p>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default OptionsLoadingState;
